// extracted by mini-css-extract-plugin
module.exports = {"newsfeed":"Kb-z"};